export default {"src":"/_next/static/media/userRoleIcon.83445bd5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};